import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import NavbarAuth from "../components/NavbarAuth.js";
import Footer from "../components/Footer.js";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { toastSuccess, toastError, toastWarning } from "../utils/Alerts.js";

const CorporateForm = () => {
  const navigate = useNavigate();
  const base_url = process.env.REACT_APP_BASE_URL;

  //Form Variable
  const [phoneNumberError, setPhoneNumberError] = useState("");
  // BUSINESS INFORMATION
  const [companyName, setCompanyName] = useState("");
  const [registerationNumber, setRegisterationNumber] = useState("");
  const [registerationDate, setRegisterationDate] = useState("");
  const [registrationCountryCode, setRegisterationCountryCode] = useState("");
  const [tin, setTin] = useState("");
  const [businessSectorCode, setBusinessSectorCode] = useState("");

  const [locationCode, setLocationCode] = useState("");
  const [addressStreet, setAddressStreet] = useState("");
  const [addressCountry, setAddressCountry] = useState("");
  const [addressCity, setAddressCity] = useState("");
  const [addressState, setAddressState] = useState("");
  const [addressCountryCode, setAddressCountryCode] = useState("");
  const [addressZipCode, setAddressZipCode] = useState("");

  const [businessPhone, setBusinessPhone] = useState("");
  const [alternatePhone, setAlternatePhone] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [alternateEmail, setAlternateEmail] = useState("");
  const [businessWebsite, setBusinessWebsite] = useState("");
  const [twitter, setTwitter] = useState("");

  // financial and bank information
  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [bvn, setBvn] = useState("");

  // SIGNATORY 1 INFORMATION
  const [signatory1Yn, setSignatory1Yn] = useState("");
  const [signatory1TitleCd, setSignatory1TitleCd] = useState("");
  const [signatory1LastName, setSignatory1LastName] = useState("");
  const [signatory1FirstName, setSignatory1FirstName] = useState("");
  const [signatory1OtherNames, setSignatory1OtherNames] = useState("");
  const [signatory1GenderCd, setSignatory1GenderCd] = useState("");
  const [signatory1BirthDate, setSignatory1BirthDate] = useState("");
  const [signatory1NationalityCd, setSignatory1NationalityCd] = useState("");
  const [signatory1JobTitle, setSignatory1JobTitle] = useState("");
  const [signatory1Telephone, setSignatory1Telephone] = useState("");
  const [signatory1EmailAddress, setSignatory1EmailAddress] = useState("");
  const [signatory1AddressStreet, setSignatory1AddressStreet] = useState("");
  const [signatory1AddressCity, setSignatory1AddressCity] = useState("");
  const [signatory1AddressCountryCd, setSignatory1AddressCountryCd] =
    useState("");
  const [signatory1BvnNumber, setSignatory1BvnNumber] = useState("");
  const [signatory1Class, setSignatory1Class] = useState("");

  // SIGNATORY 2 INFORMATION
  const [signatory2Yn, setSignatory2Yn] = useState("");
  const [signatory2TitleCd, setSignatory2TitleCd] = useState("");
  const [signatory2LastName, setSignatory2LastName] = useState("");
  const [signatory2FirstName, setSignatory2FirstName] = useState("");
  const [signatory2OtherNames, setSignatory2OtherNames] = useState("");
  const [signatory2GenderCd, setSignatory2GenderCd] = useState("");
  const [signatory2BirthDate, setSignatory2BirthDate] = useState("");
  const [signatory2NationalityCd, setSignatory2NationalityCd] = useState("");
  const [signatory2JobTitle, setSignatory2JobTitle] = useState("");
  const [signatory2Telephone, setSignatory2Telephone] = useState("");
  const [signatory2EmailAddress, setSignatory2EmailAddress] = useState("");
  const [signatory2AddressStreet, setSignatory2AddressStreet] = useState("");
  const [signatory2AddressCity, setSignatory2AddressCity] = useState("");
  const [signatory2AddressCountryCd, setSignatory2AddressCountryCd] =
    useState("");
  const [signatory2BvnNumber, setSignatory2BvnNumber] = useState("");
  const [signatory2Class, setSignatory2Class] = useState("");

  const [signatory2, setSignatory2] = useState(false);

  // FINAL INFORMATION
  const [externalReference1, setExternalReference1] = useState("string");
  const [externalReference2, setExternalReference2] = useState("string");
  const [retainCustomerId, setRetainCustomerId] = useState("string");
  const [customerRemarks, setCustomerRemarks] = useState("string");

  // Nationality and address information
  const [state, setState] = useState("");

  // const [otherName, setOtherName] = useState("");

  // STATE VARIABLES FOR DROPDOWN OPTIONS
  const [error, setError] = useState(null);
  const [titleList, setTitleList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [identityList, setIdentityList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [nationalityList, setNationalityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [lgaList, setLgaList] = useState([]);

  const [initialLgaList, setInitialLgaList] = useState([]);
  const [stList, setStList] = useState([]);

  const [signatory1StateList, setSignatory1StateList] = useState([]);
  const [signatory1LgaList, setSignatory1LgaList] = useState([]);

  const [signatory2StateList, setSignatory2StateList] = useState([]);
  const [signatory2LgaList, setSignatory2LgaList] = useState([]);
  const referer = sessionStorage.getItem("referer") || "";
  const today = new Date();
  const minDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 1
  );

  const minBirthDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );
  const [bvnError, setBVNError] = useState("");
  const [accountNumberError, setAccountNumberError] = useState("");
  // BUTTON STATE FOR SUBMIT FUNCTION

  const [buttonState, setButtonState] = useState(false);

  const handleBVNChange = (e) => {
    const inputValue = e.target.value;

    // Check if the input value consists of digits only and has length <= 11
    if (/^\d{0,11}$/.test(inputValue)) {
      setBvn(inputValue);
      setBVNError(inputValue.length < 11 ? "BVN must be 11 digits" : "");
    }
  };

  const handleAccountNumberChange = (e) => {
    const inputValue = e.target.value;

    // Check if the input value consists of digits only and has length <= 11
    if (/^\d{0,10}$/.test(inputValue)) {
      setAccountNumber(inputValue);
      setAccountNumberError(
        inputValue.length < 10 ? "Account number must be 10 digits" : ""
      );
    }
  };

  const handleStep1Submit = (e) => {
    e.preventDefault();
    const regDate = new Date(registerationDate);
    if (
      companyName &&
      registerationNumber &&
      registerationDate &&
      registrationCountryCode &&
      tin &&
      businessSectorCode &&
      locationCode
    ) {
      console.log("all set");
      console.log(
        registrationCountryCode,
        companyName,
        registerationDate,
        registrationCountryCode,
        tin,
        businessSectorCode,
        locationCode
      );

      if (regDate <= minDate) {
        setStep1(false);
        setStep2(true);
        setStep3(false);
        setStep4(false);
        setFinalStep(false);
      } else {
        // Display an error message if the date of birth indicates the person is less than 18 years old
        toastWarning("Registration Date must be today or before");
      }
    } else {
      toastWarning(
        "Please complete all fields before proceeding to the next step."
      );
    }
  };

  const handleStep2Submit = (e) => {
    const isEmailValid = ValidateEmail(businessEmail);
    e.preventDefault();
    if (
      addressCountryCode &&
      state &&
      addressCity &&
      addressStreet &&
      addressZipCode &&
      businessPhone &&
      businessEmail &&
      businessWebsite &&
      isEmailValid &&
      !phoneNumberError
    ) {
      console.log("all set");
      setStep1(false);
      setStep2(false);
      setStep3(true);
      setStep4(false);
      setFinalStep(false);
    } else if (!isEmailValid) {
      toastWarning("Ensure Business email is a valid email");
    } else {
      toastWarning(
        "Please complete all fields before proceeding to the next step."
      );
    }
  };

  const handleStep3Submit = (e) => {
    e.preventDefault();
    if (
      bankName &&
      accountName &&
      accountNumber &&
      bvn &&
      !bvnError &&
      !accountNumberError
    ) {
      console.log("all set");
      setStep1(false);
      setStep2(false);
      setStep3(false);
      setStep4(true);
      setFinalStep(false);
    } else {
      toastWarning(
        "Please complete all fields before proceeding to the next step."
      );
    }
  };

  const handleStep4Submit = (e) => {
    e.preventDefault();
    if (
      signatory1TitleCd &&
      signatory1FirstName &&
      signatory1LastName &&
      signatory1BirthDate &&
      signatory1GenderCd &&
      signatory1NationalityCd &&
      signatory1JobTitle &&
      signatory1Telephone &&
      ValidateEmail(signatory1EmailAddress) &&
      signatory1AddressCountryCd &&
      signatory1AddressCity &&
      signatory1AddressStreet
    ) {
      console.log("all set");
      setStep1(false);
      setStep2(false);
      setStep3(false);
      setStep4(false);
      setFinalStep(true);
    } else {
      toastWarning(
        "Please make sure all fields are valid before submitting form"
      );
    }
  };

  // set form state variables
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [step4, setStep4] = useState(false);
  const [finalStep, setFinalStep] = useState(false);

  //Signup error variables
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    setError(null);
    const fetchData = async () => {
      try {
        const returnData = await fetch("./data/dropdown-options.json");

        if (!returnData.ok) {
          toast.error(" Lost connection, please try again later!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

        const data = await returnData.json();

        setTitleList(data.titles.title);
        setInitialLgaList(data.lga.lga);
        setCountryList(data.countries.country);
        setStateList(data.states.state);
        setBankList(data.banks.bank);
        setNationalityList(data.nationality.nation);
        setIdentityList(data.identity.identity);
      } catch (error) {
        toast.error(" Lost connection, please try again later!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    };

    fetchData();
  }, []);

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    // Fetch the states for the selected country using an API or any data source
    // Replace 'fetchStatesForCountry' with your actual function to fetch states
    const states = stateList.filter(
      (state) => state.COUNTRY_CD === selectedCountry
    );
    console.log(states);

    setStList(states);
    // console.log(addressStList);
    // Update the selected country
    setAddressCountryCode(selectedCountry);
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    console.log(selectedState);
    // Fetch the states for the selected country using an API or any data source
    // Replace 'fetchStatesForCountry' with your actual function to fetch states

    // console.log(lga);
    console.log(lgaList);
    const lga = initialLgaList.filter((lga) => lga.STATE_CD === selectedState);
    setLgaList(lga);
    console.log(lga);

    // Update the selected country
    setState(selectedState);
  };

  const handleSignatory1CountryChange = (e) => {
    // console.log("clicked")
    const selectedCountry = e.target.value;
    const states = stateList.filter(
      (state) => state.COUNTRY_CD === selectedCountry
    );
    console.log(states);

    setSignatory1StateList(states);
    setSignatory1AddressCountryCd(selectedCountry);
    console.log();
  };

  const handleSignatory1StateChange = (e) => {
    const selectedAddressState = e.target.value;
    console.log(selectedAddressState);
    // console.log(lga);
    console.log(lgaList);
    const lga = initialLgaList.filter(
      (lga) => lga.STATE_CD === selectedAddressState
    );
    setSignatory1LgaList(lga);
    setSignatory1AddressCity(selectedAddressState);

    console.log(lga);
  };

  const handleSignatory2CountryChange = (e) => {
    // console.log("clicked")
    const selectedCountry = e.target.value;
    const states = stateList.filter(
      (state) => state.COUNTRY_CD === selectedCountry
    );
    console.log(states);

    setSignatory2StateList(states);
    setSignatory2AddressCountryCd(selectedCountry);
    console.log();
  };

  const handleSignatory2StateChange = (e) => {
    const selectedAddressState = e.target.value;
    console.log(selectedAddressState);
    // console.log(lga);
    console.log(lgaList);
    const lga = initialLgaList.filter(
      (lga) => lga.STATE_CD === selectedAddressState
    );

    setSignatory2LgaList(lga);
    setSignatory2AddressCity(selectedAddressState);

    console.log(lga);
  };

  function ValidateEmail(email) {
    var validRegex =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (email) {
      if (email.match(validRegex)) {
        return true;
      } else {
        toastWarning("Invalid email address!");
        return false;
      }
    } else {
      return false;
    }
  }

  // HANDLE SUBMIT FUNCTION
  //   const handleSubmit = (event) => {
  //     event.preventDefault();
  //     setIsPending(true);

  //     // save data to local storage
  //     const payload = {
  //       organization_name: companyName,
  //       registration_number: registerationNumber,
  //       registration_date: registerationDate,
  //       registration_country_cd: registrationCountryCode,
  //       tax_identification_number: tin,
  //       business_sector_cd: "",
  //       location_cd: "",
  //       address_street: addressStreet,
  //       address_city: addressCity,
  //       address_state_cd: addressState,
  //       address_country_cd: addressCountry,
  //       address_zip_code: addressZipCode,
  //       primary_phone_no: businessPhone,
  //       alternate_phone_no: alternatePhone,
  //       primary_email_address: businessEmail,
  //       alternate_email_address: alternateEmail,
  //       website_address: businessWebsite,
  //       twitter_address: twitter,

  //       // signatory 1
  //       signatory1_yn: "",
  //       signatory1_title_cd: signatory1TitleCd,
  //       signatory1_last_name: signatory1LastName,
  //       signatory1_first_name: signatory1FirstName,
  //       signatory1_other_names: "",
  //       signatory1_gender_cd: signatory1GenderCd,
  //       signatory1_birth_date: signatory1BirthDate,
  //       signatory1_nationality_cd: signatory1NationalityCd,
  //       signatory1_job_title: signatory1JobTitle,
  //       signatory1_telephone: signatory1Telephone,
  //       signatory1_email_address: signatory1EmailAddress,
  //       signatory1_address_street: signatory1AddressStreet,
  //       signatory1_address_city: signatory1AddressCity,
  //       signatory1_address_country_cd: signatory1AddressCountryCd,
  //       signatory1_bvn_number: signatory1BvnNumber,
  //       signatory1_class: "",

  //       // signatory 2
  //       signatory2_title_cd: signatory2TitleCd,
  //       signatory2_last_name: signatory2LastName,
  //       signatory2_first_name: signatory2FirstName,
  //       signatory2_other_names: "",
  //       signatory2_gender_cd: signatory2GenderCd,
  //       signatory2_birth_date: signatory2BirthDate,
  //       signatory2_nationality_cd: signatory2NationalityCd,
  //       signatory2_job_title: signatory2JobTitle,
  //       signatory2_telephone: signatory2Telephone,
  //       signatory2_email_address: signatory2EmailAddress,
  //       signatory2_address_street: signatory2AddressStreet,
  //       signatory2_address_city: signatory2AddressCity,
  //       signatory2_address_country_cd: signatory2AddressCountryCd,
  //       signatory2_bvn_number: signatory2BvnNumber,
  //       signatory2_class: "",
  //     };
  //     // if (referer) {
  //     //   // formData.uniqueID = referer;
  //     //   // formData.append("uniqueID", referer)
  //     //   payload.uniqueID = referer;
  //     // } else {
  //     //   // formData.append("uniqueID", "")
  //     //   payload.uniqueID = "";
  //     // }

  //     sessionStorage.setItem("Corporate", JSON.stringify(payload));

  //     console.log(payload);

  //     // make axios request with payload
  //     axios
  //       .post(`${base_url}/onboarding/create-corporate`, payload)
  //       .then((response) => {
  //         // console.log(response.data);
  //         // console.log(response);
  //         axios
  //           .post(`${base_url}/onboarding/send-corporate-email`, {
  //             uniqueID: referer,
  //             email: businessEmail,
  //           })
  //           .then((response) => {
  //             console.log(response);
  //             if (sessionStorage.getItem("individualData")) {
  //               sessionStorage.removeItem("individualData");
  //             }
  //             toastSuccess(
  //               "Your account was successfuly created. You will now be routed to product selection"
  //             );
  //             setTimeout(() => {
  //               navigate("/products");
  //             }, 5000);
  //             sessionStorage.setItem("Corporate", JSON.stringify(payload));
  //           })
  //           .catch((error) => {
  //             console.log(error);
  //           });
  //         // toastSuccess(
  //         //     "Your account was successfuly created. You will now be routed to product selection"
  //         // );
  //         // setTimeout(() => {
  //         //     navigate("/products");
  //         // }, 5000);
  //         // sessionStorage.setItem("Corporate", JSON.stringify(payload));
  //         // axios.post(`${base_url}/onboarding/send-corporate-email`, {
  //         //     uniqueID: referer,
  //         //     email: businessEmail
  //         // })
  //         //     .then((response) => {
  //         //         console.log(response);
  //         //         toastSuccess(
  //         //             "Your account was successfuly created. You will now be routed to product selection"
  //         //         );
  //         //         setTimeout(() => {
  //         //             navigate("/products");
  //         //         }, 5000);
  //         //         sessionStorage.setItem("Corporate", JSON.stringify(payload));
  //         //     })
  //         //     .catch((error) => {
  //         //         console.log(error);
  //         //     })
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         toastError(error.response.data.error);
  //       })
  //       .finally(() => {
  //         setIsPending(false);
  //       });

  //     //make sure the password verification is matched passwords match
  //   };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isPending) return;

    setIsPending(true);

    const payload = {
      organization_name: companyName,
      registration_number: registerationNumber,
      registration_date: registerationDate,
      registration_country_cd: registrationCountryCode,
      tax_identification_number: tin,
      business_sector_cd: "",
      location_cd: "",
      address_street: addressStreet,
      address_city: addressCity,
      address_state_cd: state,
      address_country_cd: addressCountryCode,
      address_zip_code: addressZipCode,
      primary_phone_no: businessPhone,
      alternate_phone_no: alternatePhone,
      primary_email_address: businessEmail,
      alternate_email_address: alternateEmail,
      website_address: businessWebsite,
      twitter_address: twitter,

      // NEW
      bank_name: bankName,
      account_name: accountName,
      account_number: accountNumber,
      bvn: bvn,

      // Relationship Manager
      uniqueID: referer || "",

      // Signatory 1
      signatory1_yn: "",
      signatory1_title_cd: signatory1TitleCd,
      signatory1_last_name: signatory1LastName,
      signatory1_first_name: signatory1FirstName,
      signatory1_other_names: "",
      signatory1_gender_cd: signatory1GenderCd,
      signatory1_birth_date: signatory1BirthDate,
      signatory1_nationality_cd: signatory1NationalityCd,
      signatory1_job_title: signatory1JobTitle,
      signatory1_telephone: signatory1Telephone,
      signatory1_email_address: signatory1EmailAddress,
      signatory1_address_street: signatory1AddressStreet,
      signatory1_address_city: signatory1AddressCity,
      signatory1_address_country_cd: signatory1AddressCountryCd,
      signatory1_bvn_number: signatory1BvnNumber,
      signatory1_class: "",

      // Signatory 2
      signatory2_title_cd: signatory2TitleCd,
      signatory2_last_name: signatory2LastName,
      signatory2_first_name: signatory2FirstName,
      signatory2_other_names: "",
      signatory2_gender_cd: signatory2GenderCd,
      signatory2_birth_date: signatory2BirthDate,
      signatory2_nationality_cd: signatory2NationalityCd,
      signatory2_job_title: signatory2JobTitle,
      signatory2_telephone: signatory2Telephone,
      signatory2_email_address: signatory2EmailAddress,
      signatory2_address_street: signatory2AddressStreet,
      signatory2_address_city: signatory2AddressCity,
      signatory2_address_country_cd: signatory2AddressCountryCd,
      signatory2_bvn_number: signatory2BvnNumber,
      signatory2_class: "",
    };

    try {
      const response = await axios.post(
        `${base_url}/onboarding/create-corporate`,
        payload
      );

      console.log(response.data);

      if (sessionStorage.getItem("individualData")) {
        sessionStorage.removeItem("individualData");
      }

      sessionStorage.setItem("Corporate", JSON.stringify(payload));

      toastSuccess(
        "Your corporate onboarding request has been submitted successfully. Our team will process it."
      );

      setTimeout(() => {
        navigate("/products");
      }, 3000);
    } catch (error) {
      console.error(error);

      toastError(
        error.response?.data?.error ||
          error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setIsPending(false);
    }
  };
  return (
    <>
      <ToastContainer />
      <NavbarAuth />
      <div className="bg-silver-gradient" style={{ minHeight: "100vh" }}>
        <br />
        <br />
        <div className="container my-5">
          <div className="row">
            <div className="col-xs-0 col-md-2"></div>
            <div className="col-xs-12 col-md-10 col-lg-8">
              <div className="d-flex btn-group mb-4">
                {/* step 1 */}
                {step1 ? (
                  <div
                    className="step-btn flex-fill flex-fill"
                    onClick={() => {
                      setStep1(true);
                      setStep2(false);
                      setStep3(false);
                      setStep4(false);
                      setFinalStep(false);
                    }}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-person-circle text-custom mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 1
                        </small>
                        <h6
                          className="text-small text-custom"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Company Info
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="" />
                                            </div> */}
                    </div>
                  </div>
                ) : (
                  <div
                    className="step-btn flex-fill mb-2"
                    onClick={() => {
                      setStep1(true);
                      setStep2(false);
                      setStep3(false);
                      setStep4(false);
                      setFinalStep(false);
                    }}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-person-circle mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 1
                        </small>
                        <h6
                          className="text-small"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Company Info
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="" />
                                            </div> */}
                    </div>
                  </div>
                )}
                {/* end step 1 */}
                <div className="flex-fill d-flex justify-content-center align-items-center text-center">
                  <div className="">
                    <hr className="horizontal-line" />
                  </div>
                </div>
                {/* step 2 */}
                {step2 ? (
                  <div
                    className="step-btn flex-fill"
                    onClick={handleStep1Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-geo-fill text-custom mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 2
                        </small>
                        <h6
                          className="text-small text-custom"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Address
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="" />
                                            </div> */}
                    </div>
                  </div>
                ) : (
                  <div
                    className="step-btn flex-fill mb-2"
                    onClick={handleStep1Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-geo-fill mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 2
                        </small>
                        <h6
                          className="text-small"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Address
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="" />
                                            </div> */}
                    </div>
                  </div>
                )}
                {/* end step 1*/}
                <div className="flex-fill d-flex justify-content-center align-items-center text-center">
                  <div className="">
                    <hr className="horizontal-line" />
                  </div>
                </div>
                {/* step 3 */}
                {step3 ? (
                  <div
                    className="step-btn flex-fill"
                    onClick={handleStep2Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-bank text-custom mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 3
                        </small>
                        <h6
                          className="text-small text-custom"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Bank Details
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="" />
                                            </div> */}
                    </div>
                  </div>
                ) : (
                  <div
                    className="step-btn flex-fill mb-2"
                    onClick={handleStep2Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-bank mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 3
                        </small>
                        <h6
                          className="text-small"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Bank Details
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                      {/* <div className="flex-fill p-2 ps-3">
                                                <hr className="" />
                                            </div> */}
                    </div>
                  </div>
                )}
                {/* end step 3 */}
                <div className="flex-fill d-flex justify-content-center align-items-center text-center">
                  <div className="">
                    <hr className="horizontal-line" />
                  </div>
                </div>
                {/* step 4 */}
                {step4 ? (
                  <div
                    className="step-btn flex-fill"
                    onClick={handleStep3Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-person- text-custom mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 4
                        </small>
                        <h6
                          className="text-small text-custom"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Signatories
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="step-btn flex-fill mb-2"
                    onClick={handleStep3Submit}
                  >
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center">
                      <div>
                        <div className="bi-person-vcard mt-2 p-1 pe-2"></div>
                      </div>
                      <div>
                        <small
                          style={{ fontSize: "10px" }}
                          className="text-secondary"
                        >
                          STEP 4
                        </small>
                        <h6
                          className="text-small"
                          style={{ marginBottom: "-5px", textAlign: "center" }}
                        >
                          Signatories
                        </h6>
                        {/* <small className="text-small" style={{fontSize:"10px"}}>Completed</small> */}
                      </div>
                    </div>
                  </div>
                )}
                {/* end step 4 */}
              </div>
              {/* LOGIN BOX */}
              <div className="login-container px-4 py-3 shadow radius-1 bg-white">
                <form onSubmit={handleSubmit} className="mt-3">
                  {step1 && (
                    <section>
                      <div className="d-flex">
                        <div>
                          <h2>
                            <i className="bi-buildings m-1 me-2 text-custom"></i>
                          </h2>
                        </div>
                        <div>
                          <h5
                            className="section-title text-custom"
                            style={{ marginBottom: "-5px" }}
                          >
                            Company Information
                          </h5>
                          <small className="text-muted">
                            Please enter your Company information
                          </small>
                        </div>
                      </div>
                      <p
                        className="mt-3 bold text-small"
                        style={{ marginBottom: "5px" }}
                      >
                        Company Information
                      </p>
                      <div className="d-flex">
                        <div className="me-1 flex-fill w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-building"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={companyName}
                              onChange={(e) => setCompanyName(e.target.value)}
                              placeholder="Company Name"
                              required
                            />
                          </div>
                        </div>

                        <div className="flex-fill w-50">
                          {/* <small>First Name</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-r-square"></i>
                            </span>
                            <input
                              type="number"
                              className="form-control custom-input-group"
                              value={registerationNumber}
                              onChange={(e) =>
                                setRegisterationNumber(e.target.value)
                              }
                              onKeyDown={(evt) =>
                                ["e", "E", "+"].includes(evt.key) &&
                                evt.preventDefault()
                              }
                              placeholder="RC Number"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill me-1 w-50">
                          {/* <small>Last Name</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small
                                className="small"
                                style={{ fontSize: "10px" }}
                              >
                                Reg Date
                              </small>
                            </span>
                            <input
                              type="date"
                              max={minDate.toISOString().split("T")[0]}
                              className="form-control custom-input-group"
                              value={registerationDate}
                              onChange={(e) =>
                                setRegisterationDate(e.target.value)
                              }
                              placeholder="Registeration Date"
                              required
                            />
                          </div>
                        </div>
                        <div className="flex-fill w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small
                                className="text-small"
                                style={{ fontSize: "10px" }}
                              >
                                Country
                              </small>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={registrationCountryCode}
                              onChange={(e) =>
                                setRegisterationCountryCode(e.target.value)
                              }
                              required
                            >
                              <option value="" selected disabled hidden>
                                Country of Residence
                              </option>
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="input-group mt-2 me-1">
                          <span class="input-group-text input-group-text-custom">
                            <i class="bi-shield-check"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control custom-input-group"
                            value={tin}
                            onChange={(e) => setTin(e.target.value)}
                            placeholder="Tax Identification"
                            required
                          />
                        </div>
                        <div className="input-group mt-2">
                          <span class="input-group-text input-group-text-custom">
                            <i class="bi-building"></i>
                          </span>
                          <select
                            className="form-control custom-input-group"
                            value={businessSectorCode}
                            onChange={(e) =>
                              setBusinessSectorCode(e.target.value)
                            }
                            required
                          >
                            <option value="" disabled>
                              Business Type
                            </option>
                            <option value="retail">Retail</option>
                            <option value="wholesale">Wholesale</option>
                            <option value="manufacturing">Manufacturing</option>
                            <option value="professional-services">
                              Professional Services
                            </option>
                            <option value="technology">Technology</option>
                            <option value="healthcare">Healthcare</option>
                            <option value="education">Education</option>
                            <option value="finance">Finance</option>
                            <option value="real-estate">Real Estate</option>
                            <option value="hospitality">Hospitality</option>
                            <option value="construction">Construction</option>
                            <option value="agriculture">Agriculture</option>
                            <option value="transportation">
                              Transportation
                            </option>
                            <option value="arts-and-entertainment">
                              Arts and Entertainment
                            </option>
                            <option value="media-and-publishing">
                              Media and Publishing
                            </option>
                            <option value="nonprofit">
                              Nonprofit Organization
                            </option>
                            <option value="personal-services">
                              Personal Services
                            </option>
                            <option value="food-and-beverage">
                              Food and Beverage Services
                            </option>
                            <option value="event-planning">
                              Event Planning and Management
                            </option>
                            <option value="sales-and-marketing">
                              Sales and Marketing
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill me-1">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small style={{ fontSize: "10px" }}>
                                Location
                              </small>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={locationCode}
                              onChange={(e) => setLocationCode(e.target.value)}
                              required
                            >
                              <option value="" selected disabled hidden>
                                Location
                              </option>
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn-custom mt-2"
                        onClick={handleStep1Submit}
                      >
                        Next
                      </button>
                    </section>
                  )}

                  {/* ADDRESS INFORMATION */}

                  {step2 && (
                    <section>
                      <div className="d-flex">
                        <div>
                          <h2>
                            <i className="bi-buildings m-1 me-2 text-custom"></i>
                          </h2>
                        </div>
                        <div>
                          <h5
                            className="section-title text-custom"
                            style={{ marginBottom: "-5px" }}
                          >
                            Company Location
                          </h5>
                          <small className="text-muted">
                            Please enter your business location.
                          </small>
                        </div>
                      </div>
                      <p
                        className="mt-3 bold text-small"
                        style={{ marginBottom: "5px" }}
                      >
                        Business Address
                      </p>

                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50">
                          {/* <small>Date of Birth</small> */}
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-pin-map"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={addressCountryCode}
                              onChange={handleCountryChange}
                              required
                            >
                              <option value="" selected hidden disabled>
                                Country
                              </option>
                              {/* <option value="Female">Female</option> */}
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="flex-fill w-50 mx-1">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-map"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={state}
                              onChange={handleStateChange}
                              required
                            >
                              <option value="" disabled selected hidden>
                                State
                              </option>
                              {stList.map((state) => {
                                return (
                                  <option value={state.STATE_CD}>
                                    {state.STATE_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="flex-fill w-50 me-1">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-pin-map"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={addressCity}
                              onChange={(e) => setAddressCity(e.target.value)}
                              required
                            >
                              <option value="" disabled selected hidden>
                                Select LGA
                              </option>
                              {lgaList.map((lga) => {
                                return (
                                  <option value={lga.LGA_CD}>
                                    {lga.LGA_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="input-group mt-2 me-1">
                          <span class="input-group-text input-group-text-custom">
                            <i class="bi bi-map"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control custom-input-group"
                            value={addressStreet}
                            onChange={(e) => setAddressStreet(e.target.value)}
                            placeholder="Street Address"
                            required
                          />
                        </div>

                        <div className="input-group mt-2">
                          <span class="input-group-text input-group-text-custom">
                            <i class="bi bi-map"></i>
                          </span>
                          <input
                            type="number"
                            className="form-control custom-input-group"
                            value={addressZipCode}
                            onChange={(e) => setAddressZipCode(e.target.value)}
                            placeholder="Address Zip Code"
                            required
                          />
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="input-group flex-fill w-70 me-1">
                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-telephone"></i>
                            </span>
                            <input
                              type="number"
                              className="form-control custom-input-group"
                              value={businessPhone}
                              onChange={(e) => {
                                const inputValue = e.target.value;

                                // Check if the input value consists of digits only and has length <= 11
                                if (/^\d{0,11}$/.test(inputValue)) {
                                  setBusinessPhone(inputValue);
                                  setPhoneNumberError(
                                    inputValue.length < 11
                                      ? "Phone number must be 11 digits"
                                      : ""
                                  );
                                }
                              }}
                              placeholder="Business Phone Number"
                              required
                            />
                          </div>
                          {phoneNumberError && (
                            <div
                              className="text-danger"
                              style={{ fontSize: "9px" }}
                            >
                              {phoneNumberError}
                            </div>
                          )}
                        </div>

                        {/* <div className="input-group mt-2">
                          <span class="input-group-text input-group-text-custom">
                            <i class="bi-telephone"></i>
                          </span>
                          <input
                            type="number"
                            className="form-control custom-input-group"
                            value={alternatePhone}
                            onChange={(e) => setAlternatePhone(e.target.value)}
                            placeholder="Alternate Phone Number"
                            required
                          />
                        </div> */}
                      </div>

                      <div className="d-flex">
                        <div className="input-group mt-2 me-1">
                          <span class="input-group-text input-group-text-custom">
                            <i class="bi-envelope"></i>
                          </span>
                          <input
                            type="email"
                            className="form-control custom-input-group"
                            value={businessEmail}
                            onChange={(e) => setBusinessEmail(e.target.value)}
                            placeholder="Business Email Address"
                            required
                          />
                        </div>

                        {/* <div className="input-group mt-2">
                          <span class="input-group-text input-group-text-custom">
                            <i class="bi-envelope"></i>
                          </span>
                          <input
                            type="email"
                            className="form-control custom-input-group"
                            value={alternateEmail}
                            onChange={(e) => setAlternateEmail(e.target.value)}
                            placeholder="Alternate Email Address"
                            required
                          />
                        </div> */}
                      </div>

                      <div className="d-flex">
                        <div className="input-group mt-2 me-1">
                          <span class="input-group-text input-group-text-custom">
                            <i class="bi-browser-chrome"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control custom-input-group"
                            value={businessWebsite}
                            onChange={(e) => setBusinessWebsite(e.target.value)}
                            placeholder="Business Website Address"
                            required
                          />
                        </div>

                        <div className="input-group mt-2">
                          <span class="input-group-text input-group-text-custom">
                            <i class="bi-twitter"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control custom-input-group"
                            value={twitter}
                            onChange={(e) => setTwitter(e.target.value)}
                            placeholder="Twitter Handle"
                            required
                          />
                        </div>
                      </div>
                      <button
                        className="btn-custom mt-2"
                        onClick={handleStep2Submit}
                        disabled={phoneNumberError}
                      >
                        Next
                      </button>
                      {phoneNumberError && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "9px" }}
                        >
                          You cannot proceed until a valid phone number is
                          entered.
                        </div>
                      )}
                    </section>
                  )}

                  {/* BANK INFO */}

                  {step3 && (
                    <section>
                      <div className="d-flex">
                        <div>
                          <h2>
                            <i className="bi-buildings m-1 me-2 text-custom"></i>
                          </h2>
                        </div>
                        <div>
                          <h5
                            className="section-title text-custom"
                            style={{ marginBottom: "-5px" }}
                          >
                            Bank Information
                          </h5>
                          <small className="text-muted">
                            Please enter your Company bank account details
                          </small>
                        </div>
                      </div>
                      <p
                        className="mt-3 bold text-small"
                        style={{ marginBottom: "5px" }}
                      >
                        Bank Information
                      </p>

                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50 me-1">
                          {/* <small>Date of Birth</small> */}
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-bank"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={bankName}
                              onChange={(e) => setBankName(e.target.value)}
                              required
                            >
                              <option>Select your Bank</option>
                              {/* <option value="Female">Female</option> */}
                              {bankList.map((bank) => {
                                return (
                                  <option value={bank.BANK_CD}>
                                    {bank.BANK_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="flex-fill w-50">
                          <div className="input-group me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-briefcase"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={accountName}
                              onChange={(e) => setAccountName(e.target.value)}
                              placeholder="Account Name"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-2">
                        <div className="flex-fill w-50 me-1">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-briefcase"></i>
                            </span>
                            <input
                              type="number"
                              className="form-control custom-input-group"
                              value={accountNumber}
                              onChange={handleAccountNumberChange}
                              placeholder="Account Number"
                              max=""
                              required
                            />
                          </div>
                          {accountNumberError && (
                            <div
                              className="text-danger"
                              style={{ fontSize: "9px" }}
                            >
                              {accountNumberError}
                            </div>
                          )}
                        </div>
                        <div className="flex-fill w-50">
                          <div className="input-group">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-briefcase"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={bvn}
                              onChange={handleBVNChange}
                              placeholder="BVN"
                              min="10000000000"
                              max="99999999999"
                              required
                            />
                          </div>
                          {bvnError && (
                            <div
                              className="text-danger"
                              style={{ fontSize: "9px" }}
                            >
                              {bvnError}
                            </div>
                          )}
                        </div>
                      </div>

                      <button
                        className="btn-custom mt-2"
                        onClick={handleStep3Submit}
                        disabled={bvnError || accountNumberError}
                      >
                        Next
                      </button>
                      {bvnError && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "9px" }}
                        >
                          You cannot proceed until a valid BVN is entered.
                        </div>
                      )}
                      {accountNumberError && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "9px" }}
                        >
                          You cannot proceed until a valid account number is
                          entered.
                        </div>
                      )}
                    </section>
                  )}

                  {/* SIGNATORY1 SECTION */}
                  {step4 && (
                    <>
                      <section>
                        <div className="d-flex">
                          <div>
                            <h2>
                              <i className="bi-people m-1 me-2 text-custom"></i>
                            </h2>
                          </div>
                          <div>
                            <h5
                              className="section-title text-custom"
                              style={{ marginBottom: "-5px" }}
                            >
                              Signatories
                            </h5>
                            <small className="text-muted">
                              Please fill in signatory information
                            </small>
                          </div>
                        </div>
                        <p
                          className="mt-3 bold text-small"
                          style={{ marginBottom: "5px" }}
                        >
                          1st Signatory Information
                        </p>
                        <div className="d-flex">
                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-person-fill"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={signatory1TitleCd}
                              onChange={(e) =>
                                setSignatory1TitleCd(e.target.value)
                              }
                              placeholder="select title"
                              required
                            >
                              <option
                                value=""
                                className=""
                                disabled
                                selected
                                hidden
                              >
                                Select Title
                              </option>
                              {titleList.map((title) => {
                                return (
                                  <option value={title.TITLE_CD}>
                                    {title.TITLE_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>

                          <div className="input-group mt-2">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-person-fill"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={signatory1FirstName}
                              onChange={(e) =>
                                setSignatory1FirstName(e.target.value)
                              }
                              placeholder="First Name"
                              required
                            />
                          </div>
                        </div>

                        <div className="d-flex">
                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-person-fill"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={signatory1LastName}
                              onChange={(e) =>
                                setSignatory1LastName(e.target.value)
                              }
                              placeholder="Last Name"
                              required
                            />
                          </div>

                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-calendar"></i>
                            </span>
                            <input
                              type="date"
                              className="form-control custom-input-group"
                              value={signatory1BirthDate}
                              onChange={(e) =>
                                setSignatory1BirthDate(e.target.value)
                              }
                              max={minBirthDate.toISOString().split("T")[0]}
                              placeholder="First Name"
                              required
                            />
                          </div>

                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <small
                                className="small"
                                style={{ fontSize: "10px" }}
                              >
                                Gender
                              </small>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={signatory1GenderCd}
                              onChange={(e) =>
                                setSignatory1GenderCd(e.target.value)
                              }
                              placeholder="select title"
                              required
                            >
                              <option value="" selected hidden disabled>
                                Select Gender
                              </option>
                              <option value="001">Male</option>
                              <option value="002">Female</option>
                            </select>
                          </div>
                        </div>

                        <div className="d-flex">
                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-pin-map"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={signatory1NationalityCd}
                              onChange={(e) =>
                                setSignatory1NationalityCd(e.target.value)
                              }
                              required
                            >
                              <option>Country</option>
                              {/* <option value="Female">Female</option> */}
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>

                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-buildings"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={signatory1JobTitle}
                              onChange={(e) =>
                                setSignatory1JobTitle(e.target.value)
                              }
                              placeholder="Occupation"
                              required
                            />
                          </div>
                        </div>

                        <div className="d-flex">
                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-telephone"></i>
                            </span>
                            <input
                              type="number"
                              className="form-control custom-input-group"
                              value={signatory1Telephone}
                              onChange={(e) =>
                                setSignatory1Telephone(e.target.value)
                              }
                              placeholder="Phone Number"
                              required
                            />
                          </div>

                          <div className="input-group mt-2">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-envelope"></i>
                            </span>
                            <input
                              type="email"
                              className="form-control custom-input-group"
                              value={signatory1EmailAddress}
                              onChange={(e) =>
                                setSignatory1EmailAddress(e.target.value)
                              }
                              placeholder="Email Address"
                              required
                            />
                          </div>
                        </div>

                        <div className="d-flex">
                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-pin-map"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={signatory1AddressCountryCd}
                              onChange={handleSignatory1CountryChange}
                              required
                            >
                              {/* <option>Country</option> */}
                              <option value="" selected disabled hidden>
                                Select Country
                              </option>
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="input-group mt-2 me-1">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi-pin-map"></i>
                            </span>
                            <select
                              className="form-control custom-input-group"
                              value={signatory1AddressCity}
                              onChange={handleSignatory1StateChange}
                              required
                            >
                              <option value="" disabled selected hidden>
                                State
                              </option>
                              {/* <option value="Female">Female</option> */}
                              {signatory1StateList.map((state) => {
                                return (
                                  <option value={state.STATE_CD}>
                                    {state.STATE_DSC}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="input-group mt-2">
                            <span class="input-group-text input-group-text-custom">
                              <i class="bi bi-map"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control custom-input-group"
                              value={signatory1AddressStreet}
                              onChange={(e) =>
                                setSignatory1AddressStreet(e.target.value)
                              }
                              placeholder="Street and House Number"
                              required
                            />
                          </div>
                        </div>
                      </section>

                      {signatory2 === false && (
                        <div>
                          <button
                            className="custom-link btn-sm my-2"
                            onClick={() => {
                              setSignatory2(true);
                            }}
                          >
                            Add a second Signatory{" "}
                            <i className="bi-plus-circle"></i>
                          </button>
                        </div>
                      )}

                      {/* signatory 2 optional */}

                      {signatory2 && (
                        <section>
                          <p
                            className="mt-3 bold text-small"
                            style={{ marginBottom: "0px" }}
                          >
                            2nd Signatory Information{" "}
                            <button
                              className="custom-link btn-sm my-2"
                              onClick={() => {
                                setSignatory2(false);
                              }}
                            >
                              {" "}
                              <i className="bi-x-circle"></i>
                            </button>
                          </p>
                          <div className="d-flex">
                            <div className="input-group mt-2 me-1">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-person-fill"></i>
                              </span>
                              <select
                                className="form-control custom-input-group"
                                value={signatory2TitleCd}
                                onChange={(e) =>
                                  setSignatory2TitleCd(e.target.value)
                                }
                                placeholder="select title"
                                required
                              >
                                <option className="" disabled>
                                  Select Title
                                </option>
                                {titleList.map((title) => {
                                  return (
                                    <option value={title.TITLE_CD}>
                                      {title.TITLE_DSC}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>

                            <div className="input-group mt-2">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-person-fill"></i>
                              </span>
                              <input
                                type="text"
                                className="form-control custom-input-group"
                                value={signatory2FirstName}
                                onChange={(e) =>
                                  setSignatory2FirstName(e.target.value)
                                }
                                placeholder="First Name"
                                required
                              />
                            </div>
                          </div>

                          <div className="d-flex">
                            <div className="input-group mt-2 me-1">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-person-fill"></i>
                              </span>
                              <input
                                type="text"
                                className="form-control custom-input-group"
                                value={signatory2LastName}
                                onChange={(e) =>
                                  setSignatory2LastName(e.target.value)
                                }
                                placeholder="Last Name"
                                required
                              />
                            </div>

                            <div className="input-group mt-2 me-1">
                              <span class="input-group-text input-group-text-custom">
                                <small
                                  className="small"
                                  style={{ fontSize: "10px" }}
                                >
                                  Birth Date
                                </small>
                              </span>
                              <input
                                type="date"
                                className="form-control custom-input-group"
                                value={signatory2BirthDate}
                                onChange={(e) =>
                                  setSignatory2BirthDate(e.target.value)
                                }
                                max={minBirthDate.toISOString().split("T")[0]}
                                placeholder="First Name"
                                required
                              />
                            </div>

                            <div className="input-group mt-2 me-1">
                              <span class="input-group-text input-group-text-custom">
                                <small
                                  className="small"
                                  style={{ fontSize: "10px" }}
                                >
                                  Gender
                                </small>
                              </span>
                              <select
                                className="form-control custom-input-group"
                                value={signatory2GenderCd}
                                onChange={(e) =>
                                  setSignatory2GenderCd(e.target.value)
                                }
                                placeholder="select title"
                                required
                              >
                                <option value="001">Male</option>
                                <option value="002">Female</option>
                              </select>
                            </div>
                          </div>

                          <div className="d-flex">
                            <div className="input-group mt-2 me-1">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-pin-map"></i>
                              </span>
                              <select
                                className="form-control custom-input-group"
                                value={signatory2NationalityCd}
                                onChange={(e) =>
                                  setSignatory2NationalityCd(e.target.value)
                                }
                                required
                              >
                                <option>Country</option>
                                {/* <option value="Female">Female</option> */}
                                {countryList.map((cou) => {
                                  return (
                                    <option value={cou.COUNTRY_CD}>
                                      {cou.COUNTRY_DSC}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>

                            <div className="input-group mt-2 me-1">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-buildings"></i>
                              </span>
                              <input
                                type="text"
                                className="form-control custom-input-group"
                                value={signatory2JobTitle}
                                onChange={(e) =>
                                  setSignatory2JobTitle(e.target.value)
                                }
                                placeholder="Occupation"
                                required
                              />
                            </div>
                          </div>

                          <div className="d-flex">
                            <div className="input-group mt-2 me-1">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-telephone"></i>
                              </span>
                              <input
                                type="number"
                                className="form-control custom-input-group"
                                value={signatory2Telephone}
                                onChange={(e) =>
                                  setSignatory2Telephone(e.target.value)
                                }
                                placeholder="Phone Number"
                                required
                              />
                            </div>

                            <div className="input-group mt-2">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-envelope"></i>
                              </span>
                              <input
                                type="email"
                                className="form-control custom-input-group"
                                value={signatory2EmailAddress}
                                onChange={(e) =>
                                  setSignatory2EmailAddress(e.target.value)
                                }
                                placeholder="Email Address"
                                required
                              />
                            </div>
                          </div>

                          <div className="d-flex">
                            <div className="input-group mt-2 me-1">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-pin-map"></i>
                              </span>
                              <select
                                className="form-control custom-input-group"
                                value={signatory2AddressCountryCd}
                                onChange={handleSignatory2CountryChange}
                                required
                              >
                                {/* <option>Country</option> */}
                                <option value="NIGERIA">Select Country</option>
                                {countryList.map((cou) => {
                                  return (
                                    <option value={cou.COUNTRY_CD}>
                                      {cou.COUNTRY_DSC}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <div className="input-group mt-2 me-1">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi-pin-map"></i>
                              </span>
                              <select
                                className="form-control custom-input-group"
                                value={signatory2AddressCity}
                                onChange={handleSignatory2StateChange}
                                required
                              >
                                <option value="">State</option>
                                {/* <option value="Female">Female</option> */}
                                {signatory2StateList.map((state) => {
                                  return (
                                    <option value={state.STATE_CD}>
                                      {state.STATE_DSC}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <div className="input-group mt-2">
                              <span class="input-group-text input-group-text-custom">
                                <i class="bi bi-map"></i>
                              </span>
                              <input
                                type="text"
                                className="form-control custom-input-group"
                                value={signatory2AddressStreet}
                                onChange={(e) =>
                                  setSignatory2AddressStreet(e.target.value)
                                }
                                placeholder="Street and House Number"
                                required
                              />
                            </div>
                          </div>
                        </section>
                      )}

                      <button
                        className="btn-custom mt-2"
                        onClick={handleStep4Submit}
                      >
                        Next
                      </button>
                    </>
                  )}

                  {finalStep && (
                    <section>
                      <div className="text-center">
                        <h1>
                          <i className="bi-person-check-fill"></i>
                        </h1>
                        <h4 className="text-muted">
                          Congratulations! You have completed the Form
                        </h4>
                        <p>
                          By clicking you consent to have read and accepted the
                          terms and conditions of Norrenberger Limited
                        </p>
                        <button
                          className="custom-link"
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(
                              "https://norrenberger.com/wp-content/uploads/2025/05/Terms-and-Conditions.pdf"
                            );
                          }}
                        >
                          Terms and Conditions of Norrenberger
                        </button>
                        <p>Click on submit to finish</p>
                      </div>
                      <div>
                        {isPending ? (
                          <button
                            className="btn-custom w-100 mt-3 btn-disabled"
                            disabled
                          >
                            <div class="spinner-border spinner-border-sm text-light ms-2"></div>
                          </button>
                        ) : (
                          <button
                            className="btn-custom w-100 my-3"
                            type="submit"
                          >
                            Submit
                          </button>
                        )}
                      </div>
                    </section>
                  )}

                  {/* {
                                        isPending ? (
                                            <button className="btn-custom w-100 mt-3 btn-disabled" disabled>
                                                Please Wait...
                                                <div class="spinner-border spinner-border-sm text-light ms-2"></div>
                                            </button>
                                        ) : (
                                            <button className="btn-custom w-100 my-3" type="submit">
                                                Continue
                                            </button>
                                        )
                                    } */}
                </form>
              </div>
            </div>

            <div className="col-xs-12 col-md-6 pt-3"></div>
          </div>
        </div>

        {/* <TermsModal /> */}
      </div>
      <Footer />
    </>
  );
};

export default CorporateForm;
